import React, { Component } from 'react';
import { Card, Grid, Label, Popup, Button, Table } from 'semantic-ui-react';
import _ from 'lodash';
import { Link } from 'react-router';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import moment from 'moment';
import numeral from 'numeral';
import hasRESTClient from '../../hocs/has-rest-client';

import EventsFeed from '../../containers/event-feed';
import { FEED_TYPES } from '../../containers/event-feed/static';
import CampaignEmailSettings from '../../containers/campaign-email-settings';
import MailoutsCreateModal from '../mailouts-create-modal';

const isEmailRecipient = member => _.includes(['TEAM_MEMBER', 'CAMPAIGN_OWNER'], member.role);

const delay = ms => new Promise((resolve, reject) => setTimeout(resolve, ms));
const textRight = { textAlign: 'right' };
class CampaignNotificationsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpened: false,
    };
  }

  toggleMailoutsModal = () => {
    this.setState(prev => ({
      modalOpened: !prev.modalOpened,
      isSubmitting: !prev.modalOpened ? false : prev.isSubmitting,
      submitError: false,
    }));
  }


  fetchMailouts() {
    this.setState({ isLoading: true });

    const { restClient, campaign } = this.props;
    const campaignJson = campaign.toJSON();
    restClient.get(`campaigns/${campaignJson.id}?include=mailouts`).then(response => {
      const mailouts = _.map(_.get(response, 'data.included'), mailout => ({ id: mailout.id, ...mailout.attributes }));
      this.setState({
        isLoading: false,
        mailouts,
      });
    }).catch(err => {
      this.setState({ isLoading: false, error: err });
    });
  }
  componentDidMount() {
    this.fetchMailouts();
  }

  postMailout = async mailout => {
    const { restClient, campaign } = this.props;
    const campaignJson = campaign.toJSON();

    const postResponse = await restClient.post('mailouts', mailout).catch(err => {
      console.log('Error creating mailout: ', err);
    });

    const mailer = _.get(postResponse, 'data.data');
    if (mailer) {
      const relationship = { type: 'mailouts', id: mailer.id };
      const relationshipDto = {
        data: relationship,
      };
      const relationshipResponse = await restClient.post(`campaigns/${campaignJson.id}/relationships/mailouts`, relationshipDto).catch(err => {
        console.log('Error creating mailout relationship: ', err);
      });
      return !_.isNil(relationshipResponse) && relationshipResponse.status === 201;
    }

    return false;
  }

  submitMailout = async payloads => {
    const { campaign, userInfo } = this.props;

    this.setState({ isSubmitting: true });

    const responses = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const payload of payloads) {
      const { creators, mailoutName: name, outreachEmailTemplate, outreachEmailSubject, utmSource } = payload;
      const campaignJson = campaign.toJSON();

      const mailout = {
        data: {
          attributes: {
            name,
            outreachEmailTemplate,
            influencers: creators,
            outreachEmailSubject,
            utmSource,
            createdBy: userInfo.name,
            createdDate: new Date(),
            campaign: {
              type: 'campaigns',
              id: campaignJson.id,
            },
          },
        },
      };
      // eslint-disable-next-line no-await-in-loop
      const response = await this.postMailout(mailout);
      // eslint-disable-next-line no-await-in-loop
      await delay(200);
      responses.push(response);
    }

    const submittedSuccessfully = _.every(responses);
    this.setState({
      isSubmitting: false,
      submitError: !submittedSuccessfully,
      modalOpened: !submittedSuccessfully,
    });
    this.fetchMailouts();
  }

  getLastSentDate = mailout => {
    const lastSentDate = _.get(mailout, 'lastSentDate');
    return lastSentDate ? moment(lastSentDate).format('YYYY-MM-DD, h:mm') : null;
  }

  getFormattedNumber = num => numeral(num).format('0,0')
  render() {
    const { modalOpened, mailouts: stateMailouts, isSubmitting, submitError } = this.state;
    const { campaign } = this.props;

    const campaignJSON = campaign.toJSON();
    const teamMembers = _.filter(campaignJSON.members, member => isEmailRecipient(member));
    const { shortlist, owner } = campaignJSON;
    const hasShortlist = !_.isNil(shortlist);
    const shortlistName = hasShortlist && shortlist.name;

    const { mailouts: campaignMailouts } = campaignJSON;
    const mailouts = _.compact(stateMailouts || campaignMailouts);

    return (
      <div style={{ margin: 30 }}>
        { modalOpened &&
          <MailoutsCreateModal
            onClose={this.toggleMailoutsModal}
            onSubmit={this.submitMailout}
            isSubmitting={isSubmitting}
            error={submitError}
            organisation={owner}
          />
        }
        <Grid fluid>
          {
            hasShortlist &&
            <Grid.Row>
              <Grid.Column width={8}>
                <Card color="blue" fluid>
                  <Card.Content>
                    <table style={{ width: '100%' }}>
                      <tr>
                        <td>
                          <h4>Campaign created from SHORTLIST</h4>
                        </td>
                        <td>
                          <Link to={`/shortlists/${shortlist.id}`}>
                            <Label color="blue" basic>{shortlistName}</Label>
                          </Link>
                        </td>
                      </tr>
                    </table>
                  </Card.Content>
                </Card>
              </Grid.Column>
            </Grid.Row>
          }
          <Grid.Row>
            <Grid.Column width={8}>
              <Card color="green" fluid>
                <Card.Content>
                  <div>
                    <div>
                      <h2>Email Settings</h2>
                      <p style={{ color: 'rgba(0,0,0,.4)' }}>
                    manage the automated campaign summary emails.
                      </p>
                    </div>
                  </div>
                  <Card fluid>
                    <Card.Content>
                      <CampaignEmailSettings campaignId={campaign.get('id')} teamMembers={teamMembers} />
                    </Card.Content>
                  </Card>
                </Card.Content>
              </Card>

              <Card color="green" fluid>
                <Card.Content>
                  <div>
                    <Grid cols>
                      <Grid.Column width={14}>
                        <h2>Influencer Mailouts</h2>
                        <p style={{ color: 'rgba(0,0,0,.4)' }}>
                          manage the outreach emails for the campaign
                        </p>
                      </Grid.Column>
                      <Grid.Column width={2}>
                        <Popup
                          trigger={
                            <Button
                              circular inverted color="green" icon="add"
                              onClick={this.toggleMailoutsModal}
                            />
                          }
                          content="Click here to create mailouts"
                        />
                      </Grid.Column>
                    </Grid>
                  </div>
                  <Card fluid>
                    <Card.Content>
                      {
                        _.isEmpty(mailouts) &&
                        <p style={{ color: 'rgba(0,0,0,.4)', fontSize: '14px' }}>
                          There are no mailouts yet
                        </p>
                      }
                      { !_.isEmpty(mailouts) && <Table basic="very">
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell singleLine>Mailout</Table.HeaderCell>
                            <Table.HeaderCell collapsing>Influencers</Table.HeaderCell>
                            <Table.HeaderCell style={textRight}>
                              <Popup
                                trigger={<span>Sent</span>}
                                content="How many times the mailout has been sent"
                              />
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {
                            _.map(mailouts, m => {
                              const lastSentDate = this.getLastSentDate(m);
                              return (<Table.Row key={m.id}>
                                <Table.Cell>
                                  <div style={{ display: 'flex', flexDirection: 'column', color: 'rgba(0,0,0,.4)' }}>
                                    <a
                                      style={{ color: '#4183c4' }}
                                      href={`/mailouts/${m.id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {m.name}
                                    </a>
                                    {lastSentDate && <span >Last Sent: {lastSentDate}</span>}
                                  </div>
                                </Table.Cell>
                                <Table.Cell textAlign="right">
                                  {_.size(m.influencers)}
                                </Table.Cell>
                                <Table.Cell textAlign="right">
                                  {_.size(m.outreachHistory)}
                                </Table.Cell>
                              </Table.Row>);
                            },
                            )
                          }
                        </Table.Body>
                        <Table.Footer fullWidth>
                          <Table.Row>
                            <Table.HeaderCell>
                              <h4>Total</h4>
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="right">
                              <h4>{this.getFormattedNumber(_.sumBy(mailouts, m => _.size(m.influencers)))}</h4>
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="right">
                              <h4>{this.getFormattedNumber(_.sumBy(mailouts, m => _.size(m.outreachHistory)))}</h4>
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Footer>
                      </Table>}
                    </Card.Content>
                  </Card>
                </Card.Content>
              </Card>


            </Grid.Column>
            <Grid.Column width={8}>
              <EventsFeed
                cardColour="pink"
                campaignId={campaign.get('id')}
                feedType={FEED_TYPES.CAMPAIGN}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

CampaignNotificationsTab.propTypes = {
  campaign: PropTypes.object.isRequired,
  restClient: PropTypes.func.isRequired,
};

export default compose(hasRESTClient)(CampaignNotificationsTab);



/** WEBPACK FOOTER **
 ** ./src/components/campaign-notifications-tab2/index.js
 **/